module.exports = {"150122100":"双河镇","150122101":"新营子镇","150122102":"五申镇","150122103":"伍什家镇","150122104":"古城镇","150122400":"托县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150122.json
// module id = 354
// module chunks = 0